import { isEmpty } from './stringUtils'

export const getFormattedAddress = (
    zip: string | undefined,
    city: string | undefined,
    street: string | undefined,
    regNo: string | undefined,
    sequentialNo: string | undefined,
    useCountry: boolean = true
) => {
    if (zip === undefined) return ''
    if (city === undefined) return ''
    var houseNum = sequentialNo === undefined ? regNo : regNo + (!isEmpty(sequentialNo) ? '/' + sequentialNo : '')
    return (
        (street ?? '') +
        (regNo !== undefined ? ' ' + houseNum + ', ' : '') +
        zip +
        ' ' +
        city +
        (useCountry === true ? ', CZ' : '')
    )
}
